import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { homePathForRole } from '../../lib/roles';

// Route guard: only allows users whose role is in `allow`. Others are sent to
// their own home. Used to keep e.g. the Admin Panel admin-only.
// (Stage 1, frontend-only. Backend enforcement comes in Stage 2.)
export const RequireRole = ({ allow, children }) => {
    const { user, isAuthenticated, loading } = useAuth();
    if (loading) return null;
    if (!isAuthenticated) return <Navigate to="/login" replace />;
    const role = user?.role;
    const allowed = Array.isArray(allow) ? allow.includes(role) : allow === role;
    if (!allowed) return <Navigate to={homePathForRole(user)} replace />;
    return children;
};
